import {Injectable} from "@angular/core";
import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {map, Observable} from "rxjs";
import {DeviceAssociation, InterDeviceAssociation} from "src/app/infrastructure/moovement-api/models/asset";
import {Samples} from "src/app/infrastructure/moovement-api/models/samples";

@Injectable({
  providedIn: 'root'
})
export class DeviceApiClient extends MoovementApiClient {



  getDeviceAssociations(deviceIds: string[]): Observable<DeviceAssociation[]> {
    return this.httpClient.post<Array<DeviceAssociation>>(`${this.baseUrl}/api/device/associations/devices`, deviceIds).pipe(
      map(das =>
        das.map(da => {
          da.id = da.deviceId + da.assetId
          return da
        })
      )
    );
  }

  associateDevice(deviceId: string, assetId: string): Observable<DeviceAssociation[]> {
    return this.httpClient.post<Array<DeviceAssociation>>(`${this.baseUrl}/api/device/${deviceId}/associations/${assetId}`, undefined).pipe(
      map(das =>
        das.map(da => {
          da.id = da.deviceId + da.assetId
          return da
        })
      )
    );
  }

  mergeAssociation(deviceAssociation: DeviceAssociation): Observable<DeviceAssociation> {
    return this.httpClient.post<DeviceAssociation>(`${this.baseUrl}/api/device/association`, deviceAssociation).pipe(
      map(da => {
        da.id = da.deviceId! + da.assetId!
        return da
      })
    );
  }

  dissociateDevice(deviceId: string): Observable<DeviceAssociation[]> {
    return this.httpClient.delete<DeviceAssociation[]>(`${this.baseUrl}/api/device/${deviceId}/associations`).pipe(
      map(das =>
        das.map(da => {
          da.id = da.deviceId + da.assetId
          return da
        })
      )
    );
  }

  updateInterDeviceAssociations(firstDeviceId: string, secondDeviceIds: string[], associationType: string): Observable<InterDeviceAssociation[]> {
    return this.httpClient.post<InterDeviceAssociation[]>(`${this.baseUrl}/api/interDeviceAssociations/bulk/update`, {
      firstDeviceId, secondDeviceIds, associationType
    });
  }

  getLatestSamples<T>(deviceIds: string[], capability: string): Observable<Samples.Sample<T>[]> {
    return this.httpClient.get<Samples.Sample<T>[]>(`${this.baseUrl}/api/last/${capability}`)
  }
}
